import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext.jsx";
import { I18nProvider, injectCoquilleTokens } from "@/coquille-bridge";
import { karateI18nNamespaces } from "@/i18n/karateI18n.js";
import { karateAppConfig } from "@/config/karateAppConfig.js";
import { AppRoutes } from "@/routes.jsx";

injectCoquilleTokens();
import "@/styles/karate.css";
import "@/styles/karate-avatar.css";
import "@/styles/karate-auth-shell.css";
import "@/styles/karate-membership.css";
import { purgeEphemeralAvatarCache } from "@/services/karateAvatarStorage.js";

purgeEphemeralAvatarCache();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <I18nProvider
      defaultLang={karateAppConfig.defaultLocale || "fr"}
      storageKey="karate-phase1.lang"
      appNamespaces={karateI18nNamespaces}
    >
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </I18nProvider>
  </React.StrictMode>,
);
